module.exports = __webpack_public_path__ + "img/pro_eight_1.2781e9cb.jpg";